/** System/internal fields that should not be validated as user-fillable */
const SYSTEM_FIELDS = new Set([
  'APPLICATION_ID',
  'PRE_APPROVED_TOTAL',
  'FINAL_APPROVED_TOTAL',
  'CARD_PRE_APPROVED_TOTAL',
  'CARD_FINAL_APPROVED_TOTAL',
  'APPROVED_COURSE_TOTAL',
  'WAIVE_EVIDENCE_ATTACHMENT_REQUIREMENT',
  'WAIVE_EVIDENCE_APPROVAL_REQUIREMENT',
  'EVIDENCE_APPROVAL_WAIVED_BY',
  'SCHOLARSHIPS_RECEIVED',
  'CLAIMS_FINANCIALS',
  'GRADE_POINT_AVERAGE',
  'PAYMENT_TYPE_FOR_DIRECT_PAY',
  // Template-level config fields (PA-authored, not employee-fillable)
  'TYPE',
  'PROGRAM_CODE',
  'PROGRAM_NAME',
  'PROGRAM_TYPE',
  'PROGRAM_DESCRIPTION',
  'PAYROLL_EXPECTATION',
  'CREATE_SIGNATURE_FLOW',
  'CLOSE_PROGRAM_BASED_ON',
  'INSTITUTION_LIST_SUPPLIED',
  'INSTITUTION_LIST_IS_EXCLUSIVE',
  'MAXIMUM_ANNUAL_REIMBURSEMENT',
  'MAXIMUM_LIFETIME_REIMBURSEMENT',
  'MAXIMUM_ANNUAL_REIMBURSEMENT_BY_EMPLOYMENT_TYPE',
  'ALLOW_UNACCREDITED_INSTITUTIONS',
  'ALLOW_PRE_APPROVAL_SUBMISSION_BEYOND_LIMIT',
  'ALLOW_WAIVER_OF_EVIDENCE_APPROVAL',
  'LOCK_EMPLOYEE_STATUS_BASED_ON',
  'CALCULATE_TOWARDS_TOTAL_BASED_ON',
  'COMPLETION_DOCUMENTS_STRING',
  'COURSE_APPROVAL_DOCUMENTS_STRING',
  // The documents-group "Required" toggle in the program builder writes required/visible
  // onto these config fields, so the required-field sweep must never treat them as fillable
  'PROGRAM_APPROVAL_DOCUMENTS_STRING',
  'PROGRAM_APPROVAL_DOCUMENTS_ATTACHMENT_FIELD',
  'COURSE_APPROVAL_DOCUMENTS_ATTACHMENT_FIELD',
  'COMPLETION_DOCUMENTS_ATTACHMENT_FIELD',
  'COURSE_INFORMATION',
  'YOUR_INFORMATION',
  'SCHOLARSHIP_NAME',
  'SCHOLARSHIP_AMOUNT',
  // Auto-computed at submit time from COURSES_BEGIN_DATE
  'SEMESTER_CODE',
]);

/**
 * Whether a template field represents employee input the draft-submit sweep should
 * demand. A field has to be required and visible, and must not be one of the
 * PA-authored config fields above: the program builder's documents-group "Required"
 * toggle writes required/visible onto its own config fields, which would otherwise
 * read as unfilled employee input and block submit-for-user on a complete draft.
 *
 * Exported so the allowlist itself is under test — a later edit that drops one of
 * these names has to fail a test rather than silently resurface the false flag.
 */
export function isEmployeeFillableTemplateField(
  fieldName: string,
  config?: { required?: boolean; visible?: boolean }
): boolean {
  return Boolean(config?.required && config?.visible && !SYSTEM_FIELDS.has(fieldName));
}
